export default __webpack_public_path__ + "static/media/Fiedler_Group_logo.478fe6b4.png";